import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { isDefined } from '@trimble-gcs/common';
import { filter, map } from 'rxjs';
import { AppRoute } from '../app-route';
import { injectLogger } from '../logging/logger-injection';
import { Role } from '../user/user.models';
import { UserState } from '../user/user.state';

export const adminRoleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const store = inject(Store);
  const router = inject(Router);
  const logger = injectLogger('AdminRoleGuard');

  return store.select(UserState.user).pipe(
    filter(isDefined),
    map((user) => {
      if (user.role === Role.Admin) return true;

      logger.error(`NoAccess: User does not have admin role.`, { user });

      return router.createUrlTree([AppRoute.NoAccess]);
    }),
  );
};
